import { Component, OnInit } from '@angular/core';
import { IStep } from '@core/model/stepper.model';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { StepsService } from 'src/app/core/services/steps.service';
import { TcoFormService } from '../../../layout/comparator/_services/forms/tco-form.service';

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
    standalone: false
})
export class StepperComponent implements OnInit {
	steps$: Observable<IStep[]>;
	currentStep$: Observable<IStep>;
	steps: IStep[];

	constructor(
		private readonly stepsService: StepsService,
		protected tcoForm: TcoFormService,
		private readonly translate: TranslateService,
	) {}

	public ngOnInit(): void {
		this.steps$ = this.stepsService.getSteps();
		this.currentStep$ = this.stepsService.getCurrentStep();
		this.steps$.pipe(take(1)).subscribe((x) => (this.steps = x));
	}

	public updateCurrentStep(step: any) {
		if (!(this.tcoForm.isBlock && step.name === 'results')) {
			this.stepsService.setCurrentStep(step);
		}
	}

	public canDeactivate() {
		this.tcoForm.canDeactivate();
	}
}
